/**
 * Embed extension with React NodeView for the editor.
 * Re-exports the base Embed with addNodeView.
 */

import { Embed } from './tiptap-embed';
import { ReactNodeViewRenderer } from '@tiptap/react';
import { EmbedView } from '../components/content/rich-text/EmbedView';

export const EmbedWithView = Embed.extend({
    addNodeView() {
        return ReactNodeViewRenderer(EmbedView);
    },
});

export default EmbedWithView;
